import styled from '@emotion/styled';

// Typography components map 1:1 to roles in ui/docs/simkura-design.md.
// Pages should prefer these over raw <h1>/<h2>/<p> tags.

export const H1Title = styled.h1`
  font-size: ${({ theme }) => theme.font.roles.pageTitle.size};
  font-weight: ${({ theme }) => theme.font.roles.pageTitle.weight};
  line-height: ${({ theme }) => theme.font.roles.pageTitle.lineHeight};
  letter-spacing: ${({ theme }) => theme.font.roles.pageTitle.tracking};
  color: ${({ theme }) => theme.font.color.primary};
  margin: 0;
`;

export const H2Title = styled.h2`
  font-size: ${({ theme }) => theme.font.roles.sectionH2.size};
  font-weight: ${({ theme }) => theme.font.roles.sectionH2.weight};
  line-height: ${({ theme }) => theme.font.roles.sectionH2.lineHeight};
  letter-spacing: ${({ theme }) => theme.font.roles.sectionH2.tracking};
  color: ${({ theme }) => theme.font.color.primary};
  margin: 0;
`;

// H3 maps to "subsection" role: 11px, uppercase, letter-spaced. Used as
// the small label inside the unified Device card sub-sections (DETAILS /
// CONNECTIVITY / etc).
export const H3Title = styled.h3`
  font-size: ${({ theme }) => theme.font.roles.subsection.size};
  font-weight: ${({ theme }) => theme.font.roles.subsection.weight};
  line-height: ${({ theme }) => theme.font.roles.subsection.lineHeight};
  letter-spacing: ${({ theme }) => theme.font.roles.subsection.tracking};
  text-transform: ${({ theme }) => theme.font.roles.subsection.transform};
  color: ${({ theme }) => theme.font.color.tertiary};
  margin: 0;
`;

export const Text = styled.p`
  font-size: ${({ theme }) => theme.font.roles.body.size};
  line-height: ${({ theme }) => theme.font.roles.body.lineHeight};
  color: ${({ theme }) => theme.font.color.primary};
  margin: 0;
`;

export const Caption = styled.span`
  font-size: ${({ theme }) => theme.font.roles.caption.size};
  line-height: ${({ theme }) => theme.font.roles.caption.lineHeight};
  color: ${({ theme }) => theme.font.color.tertiary};
`;

export const Strong = styled.strong`
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
`;
